<template>
  <div>
    <v-container fluid>
      <base-material-card
        icon="mdi-domain"
        title="ข้อมูลพื้นฐานสถานศึกษา"
        class="px-5 py-3"
        color="success"
      >
        <v-row>
          <v-col cols="12" md="6">
            <v-card class="mx-auto" outlined shaped>
              <v-list-item three-line>
                <v-list-item-content>
                  <div class="text-overline mb-4 text-primary">
                    DATA INFORMATION
                  </div>
                  <v-list-item-title class="text-h5 mb-1">
                    {{ collegeinfo.college_name }}
                  </v-list-item-title>
                  <v-list-item-subtitle>
                    รหัสสถานศึกษา: {{ collegeinfo.collegeinfo_code }}
                  </v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-avatar tile size="80" color="grey lighten-4">
                  <v-icon x-large color="success">mdi-school</v-icon>
                </v-list-item-avatar>
              </v-list-item>

              <v-divider></v-divider>

              <v-card-text>
                <v-row dense>
                  <v-col cols="12">
                    <v-icon small class="mr-2">mdi-map-marker</v-icon>
                    <strong>ที่อยู่:</strong>
                    <div class="pl-8 grey--text text--darken-2">
                      {{ collegeinfo.collegeinfo_address || "-" }}
                    </div>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-icon small class="mr-2">mdi-phone</v-icon>
                    <strong>โทรศัพท์:</strong>
                    {{ collegeinfo.collegeinfo_phone || "-" }}
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-icon small class="mr-2">mdi-fax</v-icon>
                    <strong>โทรสาร:</strong>
                    {{ collegeinfo.collegeinfo_fax || "-" }}
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-icon small class="mr-2">mdi-email</v-icon>
                    <strong>E-mail:</strong>
                    {{ collegeinfo.collegeinfo_email || "-" }}
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-icon small class="mr-2">mdi-key</v-icon>
                    <strong>Line Token:</strong>
                    {{ collegeinfo.college_tokenkey || "-" }}
                  </v-col>
                </v-row>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" text @click="collegeinfoEditmain()">
                  <v-icon left>mdi-pencil</v-icon> แก้ไขข้อมูล
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>

          <v-col cols="12" md="6">
            <v-card class="mx-auto text-center" outlined shaped height="100%">
              <v-card-text>
                <div class="text-overline mb-4 text-primary text-left">
                  DIRECTOR PROFILE
                </div>

                <div class="d-flex justify-center mb-4 relative-container">
                  <v-avatar size="200" tile class="elevation-4 rounded-xl">
                    <v-img
                      v-if="collegeinfo.collegeinfo_directorpic"
                      :src="
                        'https://hrvec.ovec.go.th/HRvecfiles/' +
                          collegeinfo.collegeinfo_directorpic
                      "
                      aspect-ratio="1"
                      class="grey lighten-2"
                    >
                      <template v-slot:placeholder>
                        <v-row
                          class="fill-height ma-0"
                          align="center"
                          justify="center"
                        >
                          <v-progress-circular
                            indeterminate
                            color="grey lighten-5"
                          ></v-progress-circular>
                        </v-row>
                      </template>
                    </v-img>
                    <v-img
                      v-else
                      src="https://via.placeholder.com/200x200?text=No+Image"
                      aspect-ratio="1"
                    ></v-img>
                  </v-avatar>
                </div>

                <div v-if="collegeinfo.collegeinfo_directorpic" class="mb-2">
                  <v-btn
                    small
                    color="error"
                    text
                    @click="deletefiledialog2 = true"
                  >
                    <v-icon left>mdi-delete</v-icon> ลบรูปภาพ
                  </v-btn>
                </div>

                <h3 class="text-h6 font-weight-bold">
                  {{ collegeinfo.collegeinfo_director || "ยังไม่ระบุข้อมูล" }}
                </h3>

                <div class="subtitle-1 mt-1">
                  <v-chip
                    v-if="collegeinfo.collegeinfo_director_type === '0'"
                    color="success"
                    small
                    label
                    outlined
                  >
                    <v-icon left small>mdi-account-check</v-icon> ผู้อำนวยการ
                  </v-chip>
                  <v-chip
                    v-else-if="collegeinfo.collegeinfo_director_type === '1' || collegeinfo.collegeinfo_director_type === 1"
                    color="warning"
                    small
                    label
                    outlined
                  >
                    <v-icon left small>mdi-account-clock</v-icon>
                    รักษาการในตำแหน่ง
                  </v-chip>
                </div>

                <div class="mt-4 grey--text text--darken-2">
                  <v-icon small>mdi-cellphone</v-icon>
                  {{ collegeinfo.collegeinfo_directorphone || "-" }}
                </div>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="warning" text @click="collegeinfoEditpic()">
                  <v-icon left>mdi-account-edit</v-icon> แก้ไข/เปลี่ยนรูป
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </base-material-card>
    </v-container>

    <v-dialog v-model="collegeinfodialog1" persistent max-width="800px">
      <v-card>
        <v-toolbar color="warning" dark flat>
          <v-toolbar-title
            ><v-icon left>mdi-pencil-box</v-icon>
            แก้ไขข้อมูลพื้นฐาน</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="collegeinfodialog1 = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>

        <v-card-text class="mt-5">
          <v-form ref="form1" lazy-validation>
            <v-row>
              <v-col cols="12" md="6">
                <v-text-field
                  label="ชื่อสถานศึกษา"
                  v-model="collegeinfo.college_name"
                  :rules="[v => !!v || 'กรุณาระบุชื่อสถานศึกษา']"
                  outlined
                  dense
                  prepend-inner-icon="mdi-school"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  label="Line Token Key"
                  v-model="college_update.college_tokenkey"
                  outlined
                  dense
                  prepend-inner-icon="mdi-key"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  label="ที่อยู่"
                  v-model="collegeinfo.collegeinfo_address"
                  outlined
                  rows="3"
                  prepend-inner-icon="mdi-map-marker"
                ></v-textarea>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="โทรศัพท์"
                  v-model="collegeinfo.collegeinfo_phone"
                  outlined
                  dense
                  prepend-inner-icon="mdi-phone"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="โทรสาร"
                  v-model="collegeinfo.collegeinfo_fax"
                  outlined
                  dense
                  prepend-inner-icon="mdi-fax"
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="4">
                <v-text-field
                  label="E-mail"
                  v-model="collegeinfo.collegeinfo_email"
                  outlined
                  dense
                  prepend-inner-icon="mdi-email"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="collegeinfodialog1 = false"
            >ยกเลิก</v-btn
          >
          <v-btn color="success" @click="editcollegeinfoSubmit1()">
            <v-icon left>mdi-content-save</v-icon> บันทึกข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="collegeinfodialog5" persistent max-width="800px">
      <v-card>
        <v-toolbar color="warning" dark flat>
          <v-toolbar-title
            ><v-icon left>mdi-account-tie</v-icon>
            แก้ไขข้อมูลผู้อำนวยการ</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click="collegeinfodialog5 = false"
            ><v-icon>mdi-close</v-icon></v-btn
          >
        </v-toolbar>

        <v-card-text class="mt-5">
          <v-form ref="form5" lazy-validation>
            <v-row>
              <v-col cols="12">
                <v-file-input
                  v-model="fileUpload"
                  label="รูปภาพผู้อำนวยการ (JPG/JPEG เท่านั้น)"
                  accept="image/jpeg, image/jpg"
                  prepend-icon="mdi-camera"
                  outlined
                  dense
                  show-size
                  truncate-length="50"
                ></v-file-input>
              </v-col>

              <v-col cols="12">
                <div class="text-subtitle-1 mb-2">สถานะตำแหน่ง:</div>
                <v-radio-group
                  v-model="collegeinfo.collegeinfo_director_type"
                  row
                >
                  <v-radio
                    value="0"
                    label="โดยตำแหน่ง (มี ผอ.)"
                    color="success"
                  ></v-radio>
                  <v-radio
                    value="1"
                    label="รักษาการ (ไม่มี ผอ.)"
                    color="warning"
                  ></v-radio>
                </v-radio-group>
              </v-col>

              <v-col cols="12" md="8">
                <v-autocomplete
                  v-model="collegeinfo.collegeinfo_director"
                  :items="personnel_temporarys"
                  item-text="frist_names"
                  item-value="frist_names"
                  label="เลือกชื่อบุคลากร"
                  outlined
                  dense
                  clearable
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-title>{{
                        item.frist_names
                      }}</v-list-item-title>
                      <v-list-item-subtitle
                        >{{ item.position_name }} :
                        {{ item.college_name }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </template>
                </v-autocomplete>
              </v-col>

              <v-col cols="12" md="4">
                <v-text-field
                  label="เบอร์โทรศัพท์"
                  v-model="collegeinfo.collegeinfo_directorphone"
                  outlined
                  dense
                  prepend-inner-icon="mdi-cellphone"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="grey" @click="collegeinfodialog5 = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            color="success"
            @click="editcollegeinfoSubmit()"
            :loading="loading"
          >
            <v-icon left>mdi-content-save</v-icon> บันทึกข้อมูล
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deletefiledialog2" max-width="400">
      <v-card>
        <v-card-title class="headline error white--text">
          <v-icon dark left>mdi-alert-circle</v-icon> ยืนยันการลบ
        </v-card-title>
        <v-card-text class="pt-4 text-center title">
          ต้องการลบรูปภาพผู้อำนวยการใช่หรือไม่?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" text @click="deletefiledialog2 = false"
            >ยกเลิก</v-btn
          >
          <v-btn color="error" @click="deletefileSubmit2()">ลบข้อมูล</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      top
      right
      :timeout="snackbar.timeout"
    >
      <v-icon left>{{ snackbar.icon }}</v-icon>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar.show = false">ปิด</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  data: () => ({
    loading: false,
    collegeinfodialog1: false,
    collegeinfodialog5: false,
    deletefiledialog2: false,
    fileUpload: null, // ตัวแปรรับไฟล์จาก v-file-input
    snackbar: {
      show: false,
      color: "",
      timeout: 3000,
      icon: "",
      text: ""
    },
    ApiKey: "HRvec2021",
    college: {},
    collegeinfo: {},
    user_update: {},
    college_update: {},
    data_syslog: {},
    personnel_temporarys: []
  }),

  async mounted() {
    await this.initData();
  },

  computed: {
    period_year_bd() {
      return new Date().getFullYear() + 543;
    },
    time_stamp() {
      return new Date().getTime();
    },
    date_today_log() {
      let today = new Date();
      let dd = String(today.getDate()).padStart(2, "0");
      let mm = String(today.getMonth() + 1).padStart(2, "0");
      let yyyy = today.getFullYear() + 543;
      let time = today.toLocaleTimeString("th-TH");
      return `${dd}/${mm}/${yyyy}/${time}`;
    }
  },

  methods: {
    async initData() {
      try {
        await this.collegeQuery();
        await this.collegeinfoQuery();
        await this.personnel_temporaryQueryAll();
      } catch (error) {
        console.error("Initialization Error:", error);
      }
    },

    async personnel_temporaryQueryAll() {
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      if (!userSession.user_province_ID) return;

      try {
        let result = await this.$http.post("personnel_temporary.php", {
          ApiKey: this.ApiKey,
          province_ID: userSession.user_province_ID
        });
        this.personnel_temporarys = result.data;
      } catch (e) {
        console.error(e);
      }
    },

    async collegeQuery() {
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      if (!userSession.user_code) return;

      let result = await this.$http.post("college.php", {
        college_code: userSession.user_code,
        ApiKey: this.ApiKey
      });
      this.college = result.data;
    },

    async collegeinfoQuery() {
      if (!this.college.college_code) return;
      let result = await this.$http.post("collegeinfo.php", {
        ApiKey: this.ApiKey,
        collegeinfo_code: this.college.college_code
      });
      this.collegeinfo = result.data;
      // Map existing token key for editing
      this.college_update.college_tokenkey = this.collegeinfo.college_tokenkey;
    },

    collegeinfoEditmain() {
      this.collegeinfodialog1 = true;
    },
    collegeinfoEditpic() {
      this.fileUpload = null; // Reset file input
      this.collegeinfodialog5 = true;
    },

    async editcollegeinfoSubmit1() {
      if (!this.$refs.form1.validate()) return;

      this.loading = true;
      try {
        // Prepare Data
        this.collegeinfo.ApiKey = this.ApiKey;
        this.user_update.ApiKey = this.ApiKey;
        this.user_update.user_code = this.collegeinfo.college_code;
        this.user_update.user_firstname = this.collegeinfo.college_name;
        this.user_update.user_director = this.collegeinfo.collegeinfo_director;
        this.user_update.user_director_type = this.collegeinfo.collegeinfo_director_type;

        this.college_update.ApiKey = this.ApiKey;
        this.college_update.college_code = this.collegeinfo.college_code;
        this.college_update.college_name = this.collegeinfo.college_name;

        // Execute Requests
        const [resInfo, resUser, resCollege] = await Promise.all([
          this.$http.post("collegeinfo.update.php", this.collegeinfo),
          this.$http.post("user.update.code.php", this.user_update),
          this.$http.post("college.update.code.php", this.college_update)
        ]);
        if (
          resInfo.data.status ||
          resUser.data.status ||
          resCollege.data.status
        ) {
          this.showSnackbar("success", "บันทึกข้อมูลเรียบร้อย");
          await this.collegeinfoQuery();
          this.collegeinfodialog1 = false;
        } else {
          this.showSnackbar("error", "บันทึกข้อมูลผิดพลาด");
        }
      } catch (error) {
        this.showSnackbar("error", "เกิดข้อผิดพลาดในการเชื่อมต่อ");
      } finally {
        this.loading = false;
      }
    },

    async editcollegeinfoSubmit() {
      this.loading = true;
      try {
        let uploaded = true;

        // 1. Handle File Upload
        if (this.fileUpload) {
          if (
            this.fileUpload.type === "image/jpeg" ||
            this.fileUpload.type === "image/jpg"
          ) {
            let formData = new FormData();
            let filename = `${this.collegeinfo.collegeinfo_code}.${this.time_stamp}.${this.period_year_bd}.directorpic.jpg`;

            formData.append("file", this.fileUpload);
            formData.append("filename", "../HRvecfiles/" + filename);
            formData.append("ApiKey", this.ApiKey);

            await this.$http.post("uploadfile.php", formData, {
              headers: { "Content-Type": "multipart/form-data" }
            });

            this.collegeinfo.collegeinfo_directorpic = filename;
          } else {
            this.showSnackbar(
              "warning",
              "กรุณาแนบไฟล์ .jpg หรือ .jpeg เท่านั้น"
            );
            this.loading = false;
            return;
          }
        }

        // 2. Update Database Info
        this.collegeinfo.ApiKey = this.ApiKey;
        this.user_update.ApiKey = this.ApiKey;
        this.user_update.user_code = this.collegeinfo.college_code;
        this.user_update.user_firstname = this.collegeinfo.college_name;
        this.user_update.user_director = this.collegeinfo.collegeinfo_director;
        this.user_update.user_director_type = this.collegeinfo.collegeinfo_director_type;

        const [resInfo, resUser] = await Promise.all([
          this.$http.post("collegeinfo.update.php", this.collegeinfo),
          this.$http.post("user.update.code.php", this.user_update)
        ]);

        if (resInfo.data.status || resUser.data.status) {
          this.showSnackbar("success", "บันทึกข้อมูลเรียบร้อย");

          // Log System
          await this.saveLog("update_img");

          await this.collegeinfoQuery();
          this.collegeinfodialog5 = false;
        } else {
          this.showSnackbar("error", "บันทึกข้อมูลผิดพลาด");
        }
      } catch (error) {
        console.error(error);
        this.showSnackbar("error", "เกิดข้อผิดพลาดของระบบ");
      } finally {
        this.loading = false;
      }
    },

    async deletefileSubmit2() {
      try {
        await this.$http.post("deletefile.php", {
          ApiKey: this.ApiKey,
          filename: "../HRvecfiles/" + this.collegeinfo.collegeinfo_directorpic
        });

        await this.$http.post("collegeinfo.update.php", {
          ApiKey: this.ApiKey,
          collegeinfo_directorpic: "",
          period_year: this.period_year,
          collegeinfo_code: this.collegeinfo.collegeinfo_code
        });

        this.user_update.ApiKey = this.ApiKey;
        this.user_update.user_code = this.collegeinfo.college_code;
        this.user_update.user_directorpic = "";
        await this.$http.post("user.update.code.php", this.user_update);

        this.showSnackbar("success", "ลบรูปภาพเรียบร้อย");
        await this.saveLog("delete_img");
        await this.collegeinfoQuery();
      } catch (error) {
        this.showSnackbar("error", "ไม่สามารถลบไฟล์ได้");
      } finally {
        this.deletefiledialog2 = false;
      }
    },

    async saveLog(event) {
      let userSession = JSON.parse(localStorage.getItem("user")) || {};
      this.data_syslog.ApiKey = this.ApiKey;
      this.data_syslog.user_account = userSession.user_name;
      this.data_syslog.event_log = event;
      this.data_syslog.page_log = "collegeinfo";
      this.data_syslog.table_log = "collegeinfo,user,college";
      this.data_syslog.detail_log = this.collegeinfo.collegeinfo_name;
      this.data_syslog.date_times = this.date_today_log;
      await this.$http.post("data_syslog.insert.php", this.data_syslog);
    },

    showSnackbar(type, text) {
      this.snackbar.color =
        type === "success"
          ? "success"
          : type === "warning"
          ? "orange darken-2"
          : "red darken-2";
      this.snackbar.icon =
        type === "success" ? "mdi-check-circle" : "mdi-alert";
      this.snackbar.text = text;
      this.snackbar.show = true;
    }
  },

  watch: {
    async period_year_bd() {
      await this.collegeinfoQuery();
    }
  }
};
</script>

<style scoped>
.relative-container {
  position: relative;
}
</style>
